export const AnalyticAppName = 'PilotWebApp';
export const AnalyticPlatform = 'Web';
